import { render, staticRenderFns } from "./AllExamResults.vue?vue&type=template&id=f64dd9be"
import script from "./AllExamResults.vue?vue&type=script&lang=js"
export * from "./AllExamResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports